export const columna = [

	

   {
		"nombre": "Noticias.",
		"imagen": 'noticias/transparencia.jpg',
	   "funcion": 'La transparencia se comparte.',
		"url" : 'https://www.facebook.com/share/r/1BX5qo7frJ',
	},


	{
		"nombre": "Noticias.",
		"imagen": 'noticias/transparencia2026.jpg',
	    "funcion": 'XXI Concurso Nacional.',
		"url" : 'https://www.facebook.com/SecretariaContraloriaHgo/posts/pfbid0E86bfyQ54Y4FW8fQQTi5vk4fTukgbFhiAsicsfATZe484A5NvVwtoWeQsBNTk4Cdl?rdid=4L6PKquzOMG0a1ZI#',
	},

	
	{
		"nombre": "Noticias.",
		"imagen": 'noticias/juridicoia.jpg',
	    "funcion": 'Marco Jurídico IA.',
		"url" : 'https://www.facebook.com/share/r/1Hp6hUCTCd',
	},

	{
		"nombre": "Noticias.",
		"imagen": 'noticias/buzón.jpg',
		"funcion": "Buzón Digital",
		"url": "https://buzondigitalcontraloria.hidalgo.gob.mx/"
	},

	// // {
	// 	"nombre": "Podcast del Pueblo",
	// 	"imagen": 'noticias/comisarios.jpg',
	// 	"funcion": '"Hidalgo Honesto"',
	// 	"url" : 'https://www.facebook.com/100064535929070/videos/755046710063599/?__so__=permalink&locale=es_LA',
	// },
		



]